import React from 'react';
import { Col, Alert, Modal, Form, Input, Select, Button } from 'antd';
import { appVariables } from '@constants';

const { Option } = Select;

const layout = {
	labelCol: { span: 8 },
	wrapperCol: { span: 14 },
};

const CommissionSummaryEditTransferModal = ({
	formRef,
	summaryForm: { rowVal },
	modalOptions: { modalType, modalVisible },
	onFinishModal,
	handleSummaryForm,
	setModalOptionsValues,
	editCommissionSummaryByIDLoading,
	editCommissionSummaryByIDError,
}) => {
	const modalTitleText = modalType === appVariables.EDIT_COMMISSION ? 'Edit' : 'Transfer';
	formRef.setFieldsValue(rowVal)
	return (
		<Modal
			visible={modalVisible}
			title={null}
			centered={true}
			footer={null}
			closable={false}
			style={{ minWidth: '50%' }}
			destroyOnClose={true}
			className="view_summary_modal">
			<Col>
				<Col className="modal_header">{modalTitleText} Commission</Col>
				<Col className="modal_Body">
					{editCommissionSummaryByIDError && <Alert
						message={editCommissionSummaryByIDError.msg}
						type="error"
						closable
					/>}
					<Form
						hideRequiredMark={true}
						style={{ margin: '20px 0px' }}
						{...layout}
						layout="horizontal"
						form={formRef}
						onFinish={(val)=>onFinishModal(val, modalType)}>
						<Form.Item className="full_border" name="affName" label="Affiliate Name" rules={[]}>
							<Select defaultValue="lucy" style={{ width: '100%' }} className="commission_dd">
								<Option value="jack">Jack</Option>
								<Option value="lucy">Lucy</Option>
								<Option value="disabled" disabled>
									Disabled
								</Option>
								<Option value="Yiminghe">yiminghe</Option>
							</Select>
						</Form.Item>
						<Form.Item className="full_border" name="customerEmail" label="Company Name" rules={[]}>
							<Input />
						</Form.Item>
						<Form.Item className="full_border" name="customerName" label="Customer" rules={[]}>
							<Input />
						</Form.Item>
						<Form.Item className="full_border" name="orderId" label="Order Id" rules={[]}>
							<Input />
						</Form.Item>
						<Form.Item className="full_border" name="productName" label="Product" rules={[]}>
							<Input />
						</Form.Item>
						<Form.Item className="full_border" name="productPrice" label="Product Price" rules={[]}>
							<Input />
						</Form.Item>
						<Form.Item className="full_border" name="commissionPercenatage" label="Commission %" rules={[]}>
							<Input />
						</Form.Item>
						<Form.Item className="full_border" name="commissionPrice" label="Commission Price" rules={[]}>
							<Input disabled />
						</Form.Item>
						<Col style={{ textAlign: 'right' }}>
							<Button className="cancel_btn" onClick={()=>{
							 	formRef.resetFields()
								setModalOptionsValues()
								}}>
								Cancel
							</Button>
							<Button
								className="submit_btn"
								htmlType="submit"
								// onClick={(e) => handleSummaryForm('summaryModal', false)}
								loading={editCommissionSummaryByIDLoading}>
								Submit
							</Button>
						</Col>
					</Form>
				</Col>
			</Col>
		</Modal>
	);
};

export default CommissionSummaryEditTransferModal;
